export function currentUnixTime(): number {
  return Date.now() / 1000;
}
